import React, { ReactNode } from "react";

import _ from "lodash";
import cx from "classnames";
import Tooltip from "../tooltip";
import styles from './style.module.scss';

interface TruncateProps {
  width?: number;
  lines?: number;
  className?: string;
  children: ReactNode;
  tooltipText?: string;
}

const Truncate: React.FC<TruncateProps> = ({ width = 300, lines = 1, className, children, tooltipText }) => {
  if (_.size(tooltipText) > 0) {
    return (
      <Tooltip content={tooltipText} placement='bottom'>
        <span style={{ maxWidth: width }} className={cx(styles.truncate, className)}>
          {children}
        </span>
      </Tooltip>
    );
  }
  
  return (
    <span style={{ maxWidth: width }} className={cx(styles.truncate, className)}>
      {children}
    </span>
  );
};

export default Truncate;
